import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

const Header = styled.header`
  position: sticky;
  top: 0px;
  background: #000;
  z-index: 1;
`

const Wrapper = styled.div`
  margin: 0 auto;
  height: 80px;
  max-width: 1280px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const TopBar = ({ children }) => (
  <Header>
    <Wrapper>{children}</Wrapper>
  </Header>
)

Header.propTypes = {
  children: PropTypes.node.isRequired,
}

export default TopBar
